import * as types from 'constants/ActionTypes';
import { CHAT } from 'constants/ExtensionConstants';
import { GET_MODAL_DEALERS_SUCCESS, GET_PAGINATED_DEALERS_FETCH_SUCCESS } from 'modules/dealers/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import { mergeByExtensions } from './utils';
import { changeDealerStatusSuccessReducer } from '../../utils/DealersReducersUtils';

// Contains all dealer ids that have been fetched so far for the CHAT feature
const initialState = [];

const initialStateReducer = () => initialState;

const fetchDealersSuccessReducer = (state, { payload }) => mergeByExtensions(state, payload.content, CHAT);

const fetchDealerSuccessReducer = (state, { payload: dealer }) =>
  fetchDealersSuccessReducer(state, { payload: { content: [dealer] } });

export default createReducer(initialState, {
  [GET_MODAL_DEALERS_SUCCESS]: fetchDealersSuccessReducer,
  [GET_PAGINATED_DEALERS_FETCH_SUCCESS]: fetchDealersSuccessReducer,
  [types.FETCH_DEALER_SUCCESS]: fetchDealerSuccessReducer,
  [types.FETCH_DEALERS_SELECT_FAILURE]: initialStateReducer,
  [types.FETCH_DEALERS_SELECT_SUCCESS]: fetchDealersSuccessReducer,
  [types.CHANGE_DEALER_STATUS_SUCCESS]: changeDealerStatusSuccessReducer,
});
